import PriceUpdateFlags = Modules.BookingExperts.Enums.PriceUpdateFlags;

// todo: check if automatically generated enum can be used (was already broken in previous version)
const PriceUpdateFlagsEnum = {
	None: 0,
	NoPreviousYearData: 1,
	CantScaleEndAtZero: 2,
	NoData: 4,
} as const satisfies Record<string, number>;

const FLAG_MESSAGES: Partial<Record<PriceUpdateFlags, string>> = {
	[PriceUpdateFlagsEnum["CantScaleEndAtZero"]]: "Unable to scale",
	[PriceUpdateFlagsEnum["NoPreviousYearData"]]:
		"Previous year data unavailable",
	[PriceUpdateFlagsEnum["NoData"]]: "No capacity data available.",
};

export function getFlagMessage(flags?: number): string[] {
	if (!flags) return [];
	const messages: string[] = [];

	for (const flag of Object.values(PriceUpdateFlagsEnum)) {
		if ((flags & flag) != 0b0) messages.push(FLAG_MESSAGES[flag]);
	}

	return messages;
}
